"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCameraAccessDeniedError = void 0;
// checks if the error from navigator.mediaDevices.getUserMedia is because of denied permission by user
function isCameraAccessDeniedError(e) {
    return e instanceof DOMException && (e.name === "NotAllowedError" || e.name === "SecurityError");
}
exports.isCameraAccessDeniedError = isCameraAccessDeniedError;
//# sourceMappingURL=camera-utils.js.map